import { captureNode, waitForImagesInNode } from '../capture-image-utils'

const captureAppleFrontPreview = async () => {
  const node = document.getElementById('appleFront')

  if (!node) throw new Error('Apple front preview node not found')

  node.classList.add("preview")
  const editIcons = Array.from(node.querySelectorAll(".editIcon"))
  const previousVisibility = editIcons.map(icon => icon.style.visibility)
  editIcons.forEach(icon => {
    icon.style.visibility = "hidden"
  })

  try {
    await waitForImagesInNode(node)
    return await captureNode(node)
  }
  finally {
    editIcons.forEach((icon, idx) => {
      icon.style.visibility = previousVisibility[idx]
    })
    node.classList.remove("preview")
  }
}

export default captureAppleFrontPreview
